import { useEffect, useState, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../../assets/images/logo-dark.png";
import { Container } from "react-bootstrap";
import { Button } from "antd";
import "./styles.scss";

interface HeaderProps {}

const Header: React.FC<HeaderProps> = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [show, setShow] = useState<boolean>(true);
  const [lastScrollY, setLastScrollY] = useState<number>(0);
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  const controlNavbar = useCallback((): void => {
    if (typeof window !== "undefined") {
      if (window.scrollY > lastScrollY) {
        setShow(false);
      } else {
        setShow(true);
      }
      setLastScrollY(window.scrollY);
    }
  }, [lastScrollY]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", controlNavbar);
      return () => {
        window.removeEventListener("scroll", controlNavbar);
      };
    }
  }, [controlNavbar]);

  const toggleMenu = (): void => {
    setMenuOpen((prev: boolean) => !prev);
  };

  return (
    <div className={`Header ${!show ? "Scrolled" : ""}`}>
      <Container>
        <div className="Header-Box">
          <div className="Header-Box1">
            <img
              src={logo}
              alt="logo"
              className="Header-logo"
              onClick={() => {
                navigate("/");
                window.scrollTo(0, 0);
              }}
            />
          </div>
          <div className="Header-Mobile-Toggle" onClick={toggleMenu}>
            <span className={`hamburger ${menuOpen ? "open" : ""}`}></span>
          </div>
          <div className={`Header-Box2 ${menuOpen ? "open" : ""}`}>
            <div
              className={`Header-text1 ${
                location.pathname === "/features" ? "active" : ""
              }`}
              onClick={() => {
                navigate("/features");
                setMenuOpen(false);
                window.scrollTo(0, 0);
              }}
            >
              Features
            </div>

            <div
              className={`Header-text1 ${
                location.pathname === "/biometricintegration" ? "active" : ""
              }`}
              onClick={() => {
                navigate("/biometricintegration");
                setMenuOpen(false);
                window.scrollTo(0, 0);
              }}
            >
              Biometric Integration
            </div>
            <div
              className={`Header-text1 ${
                location.pathname === "/contactus" ? "active" : ""
              }`}
              onClick={() => {
                navigate("/contactus");
                setMenuOpen(false);
                window.scrollTo(0, 0);
              }}
            >
              Contact
            </div>
          </div>
          <div className="Header-Box3">
            <Button
              onClick={() => {
                navigate("/contact");
                window.scrollTo(0, 0);
              }}
              type="primary"
            >
              Enquiry
            </Button>
            <Button onClick={() => navigate("/login")} type="primary">
              Agent Login
            </Button>
            <Button type="primary">
              <a
                href="https://admin.xentrybook.com/"
                style={{ textDecoration: "none" }}
              >
                Office Login
              </a>
            </Button>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Header;
